export const parseURLParams = <T>(params: URLSearchParams, key: string, defaultValue: T): T => {
  const param = params.get(key);

  if (param === null || param === undefined || param === '') {
    return defaultValue;
  }

  return param as T;
};
